import axiosInstance from "../axios";

export const login = ({ mobileNumber, password, code }) => {
  return axiosInstance.post("/auth/login", {
    mobile: mobileNumber,
    password: password,
    code: code,
  });
};

export const loginOtp=({mobileNumber, otp}) => {
  return axiosInstance.post("/auth/login", {
    mobile: mobileNumber,
    otp_code: otp,
  });
}

export const fetchOtp = ({ mobileNumber, from = "login" }) => {
  return axiosInstance.post(`/auth/generate_otp`, {
    mobile: mobileNumber,
    from,
  });
};

export const register = ({
  fullName,
  companyName,
  mobileNumber,
  password,
  profile,
  size,
  buildMode,
  otp,
}) => {
  return axiosInstance.post("/users/register", {
    name: fullName,
    company: companyName,
    mobile: mobileNumber,
    password: password,
    profile: profile,
    size: size,
    build_mode: buildMode,
    otp_code: otp,
  });
};

export const getCurrentUser = () => {
  const currentUser = localStorage.getItem("currentUser");

  return JSON.parse(currentUser);
};

export const setUserAsGuest = () => {
  localStorage.clear("accessToken");
  localStorage.clear("currentUser");
};

export const setAuthenticatedUser = ({ token, user }) => {
  localStorage.setItem("accessToken", token);
  localStorage.setItem("currentUser", JSON.stringify(user));
};

export const setUserFromLandingPage = (user) => {
  localStorage.setItem("currentUser", JSON.stringify(user));
};
